import React from "react";
import { generateUnremittedForeignPdf } from "./generator";
import PdfBase from "../../Others/Pdf/PdfBase";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  currentYearUnremittedForeignRows,
  previousYearUnremittedForeignRows,
  foreignSourceTrackingRows,
  trackingSubtotals,
  summaryData,
  foreignTaxCreditScheduleRef,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    currentYearUnremittedForeignRows,
    previousYearUnremittedForeignRows,
    foreignSourceTrackingRows,
    trackingSubtotals,
    summaryData,
    foreignTaxCreditScheduleRef,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateUnremittedForeignPdf(forView, ...sharedArgs)
        }
        downloadName='Unremitted Foreign Income Tracking Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateUnremittedForeignPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
